import { Box, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { FormProvider } from "react-hook-form";
import { useSelector } from "react-redux";
import { getQueryParams } from "shared/helpers/getQueryParams";
import { useAsyncDispatch } from "shared/helpers/hooks/useAsyncDispatch";
import useTranslation from "shared/helpers/hooks/useTranslation";
import BasicAutocomplete from "shared/ui/Autocomplete";
import ButtonLoader from "shared/ui/ButtonLoader";
import BasicRangePicker from "shared/ui/RangePicker";
import { IAttachedEmployee } from "store/interfaces/directorates";
import {
  GetFeedbackFilterValues,
  selectFeedbackFilterValues,
} from "store/slicers/feedback";

const ExportFeedbacksComponent = ({ onSubmit, isLoading, methods }) => {
  const t = useTranslation();
  const dispatch = useAsyncDispatch();
  const [isAutocompleteLoading, setAutocompleteLoading] = useState(false);
  const filterValues = useSelector(selectFeedbackFilterValues);

  const getCampaignList = useCallback(
    async (value: string) => {
      try {
        setAutocompleteLoading(true);

        const formData = {
          filter: "campaignname",
          term: value,
          count: 15,
        };

        await dispatch(GetFeedbackFilterValues(getQueryParams(formData)));
      } catch (error) {
        setAutocompleteLoading(false);
      } finally {
        setAutocompleteLoading(false);
      }
    },
    [dispatch]
  );

  const init = useCallback(
    async (initialSearchText) => {
      if (!initialSearchText) {
        getCampaignList(initialSearchText);
      }
    },
    [dispatch]
  );

  useEffect(() => {
    init(methods.watch("config.quickFilters.campaign.value"));
  }, [init]);

  return (
    <FormProvider {...methods}>
      <BasicRangePicker name="config.quickFilters.range" />
      <Box
        sx={{
          pt: 2,
        }}
      >
        <BasicAutocomplete<IAttachedEmployee>
          loading={isAutocompleteLoading}
          options={filterValues?.campaign || []}
          inputLabel="Campaign"
          name="config.quickFilters.campaign"
          optionLabel="label"
          defaultValue={""}
          size="medium"
          async
          fetchFn={getCampaignList}
        />
      </Box>

      <Box mt={2} width={"100%"} display="flex" justifyContent="flex-end">
        <ButtonLoader
          onClick={onSubmit}
          isLoading={isLoading}
          disabled={
            methods.watch("config.quickFilters.range")?.[0] &&
            methods.watch("config.quickFilters.range")?.[1]
              ? false
              : true
          }
        >
          <Typography>{t("apply")}</Typography>
        </ButtonLoader>
      </Box>
    </FormProvider>
  );
};

export default ExportFeedbacksComponent;
